// src/containers/Codes/materialsCodes.js

import CodeSet from './CodeSet';

const materialsCodes = new CodeSet('materials', { fr: 'matériaux', it: 'materiali', es: 'materiales', de: 'materialien', da: 'materialer', nl: 'materialen', no: 'materialer', sv: 'material' });

// Wool (0)
materialsCodes.addData(0, {
  name: { en: 'wool', fr: 'laine', it: 'lana', es: 'lana', de: 'wolle', da: 'uld', nl: 'wol', no: 'ull', sv: 'ull' },
  text: { en: '', fr: '', it: '', es: '', de: '', da: '', nl: '', no: '', sv: '' },
  color: 'cornsilk'
});

// Cotton (1)
materialsCodes.addData(1, {
  name: { en: 'cotton', fr: 'coton', it: 'cotone', es: 'algodón', de: 'baumwolle', da: 'bomuld', nl: 'katoen', no: 'bomull', sv: 'bomull' },
  text: { en: '', fr: '', it: '', es: '', de: '', da: '', nl: '', no: '', sv: '' },
  color: 'chocolate'
});

// Synthetic (2)
materialsCodes.addData(2, {
  name: { en: 'synthetic', fr: 'synthétique', it: 'sintetico', es: 'sintético', de: 'synthetisch', da: 'syntetisk', nl: 'synthetisch', no: 'syntetisk', sv: 'syntetisk' },
  text: { en: '', fr: '', it: '', es: '', de: '', da: '', nl: '', no: '', sv: '' },
  color: 'teal'
});

// Leather (3)
materialsCodes.addData(3, {
  name: { en: 'leather', fr: 'cuir', it: 'pelle', es: 'cuero', de: 'leder', da: 'læder', nl: 'leer', no: 'lær', sv: 'läder' },
  text: { en: '', fr: '', it: '', es: '', de: '', da: '', nl: '', no: '', sv: '' },
  color: 'tan'
});

// Silk (4)
materialsCodes.addData(4, {
  name: { en: 'silk', fr: 'soie', it: 'seta', es: 'seda', de: 'seide', da: 'silke', nl: 'zijde', no: 'silke', sv: 'silke' },
  text: { en: '', fr: '', it: '', es: '', de: '', da: '', nl: '', no: '', sv: '' },
  color: 'white'
});

// Jute (5)
materialsCodes.addData(5, {
  name: { en: 'jute', fr: 'jute', it: 'iuta', es: 'yute', de: 'jute', da: 'jute', nl: 'jute', no: 'jute', sv: 'jute' },
  text: { en: '', fr: '', it: '', es: '', de: '', da: '', nl: '', no: '', sv: '' },
  color: 'burlywood'
});

// Sisal (6)
materialsCodes.addData(6, {
  name: { en: 'sisal', fr: 'sisal', it: 'sisal', es: 'sisal', de: 'sisal', da: 'sisal', nl: 'sisal', no: 'sisal', sv: 'sisal' },
  text: { en: '', fr: '', it: '', es: '', de: '', da: '', nl: '', no: '', sv: '' },
  color: 'wheat'
});

// Cashmere (7)
materialsCodes.addData(7, {
  name: { en: 'cashmere', fr: 'cachemire', it: 'cachemire', es: 'cachemir', de: 'kaschmir', da: 'kashmir', nl: 'kasjmier', no: 'kasjmir', sv: 'kashmir' },
  text: { en: '', fr: '', it: '', es: '', de: '', da: '', nl: '', no: '', sv: '' },
  color: 'cornsilk'
});


export default materialsCodes;
